import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./EmailListMenu.scss";

const EmailListMenu: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string): boolean => {
    return location.pathname === path;
  };

  const menuItems = [
    {
      id: "inbox",
      path: "/email/inbox",
      icon: "bi-inbox-fill",
      label: "Inbox",
      // badge: 12
    },
    {
      id: "starred",
      path: "/email/starred",
      icon: "bi-star",
      label: "Starred",
    },
    {
      id: "sent",
      path: "/email/sent",
      icon: "bi-send",
      label: "Sent",
    },
    {
      id: "non-actionable",
      path: "/email/non-actionable",
      icon: "bi bi-envelope-slash",
      label: "Non-Actionable",
    },
  ];

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="email-sidebar">
        {/* New Email Button */}
        <Link to="/email/compose" className="email-sidebar__new-btn">
          <i className="bi bi-plus text-white"></i>
          <span>New Email</span>
        </Link>

        {/* Menu Items */}
        <div className="email-sidebar__menu-card">
          <nav className="email-sidebar__menu">
            {menuItems.map((item) => (
              <Link
                key={item.id}
                to={item.path}
                className={`email-sidebar__item ${
                  isActive(item.path) ? "email-sidebar__item--active" : ""
                }`}
              >
                <span className="email-sidebar__icon">
                  <i className={`bi ${item.icon}`}></i>
                </span>
                <span className="email-sidebar__text">{item.label}</span>
                {/* {item.badge && (
                  <span className="email-sidebar__badge">{item.badge}</span>
                )} */}
              </Link>
            ))}
          </nav>
        </div>
      </div>

      {/* Mobile Tabs */}
      <div className="email-mobile-tabs">
        <div className="email-mobile-tabs__container">
          {menuItems.map((item) => (
            <Link
              key={item.id}
              to={item.path}
              className={`email-mobile-tabs__item ${
                isActive(item.path) ? "email-mobile-tabs__item--active" : ""
              }`}
            >
              <span className="email-mobile-tabs__label">{item.label}</span>
              {isActive(item.path) && (
                <span className="email-mobile-tabs__indicator"></span>
              )}
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default EmailListMenu;
